import { ActionsUnion } from '../../utils/types'
import { createAction } from '../../utils/redux'

export const TOKEN_LOADED = 'user/TOKEN_LOADED'
export const SET_TOKEN = 'user/SET_TOKEN'

export const LOGIN = 'user/LOGIN'
export const LOGOUT = 'user/LOGOUT'
export const RESET = 'user/RESET'

export const UserActions = {
  login: (email: string, password: string) => createAction(LOGIN, { email, password }),
  setToken: (token: string, role: string) => createAction(SET_TOKEN, { token, role }),
  logout: (refreshToken: string) => createAction(LOGOUT, { refreshToken }),
  reset: () => createAction(RESET)
}

export type UserActions = ActionsUnion<typeof UserActions>
